module.exports = __webpack_public_path__ + "img/case_dark_icon.fcfd118d.svg";